import './App.css';
import MapContainer from "./MapContainer";

const App: React.FC = () => {
    return (
        <div className="App">
            <MapContainer />
        </div>
    );
};

export default App;
